import axios from 'axios';
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../../components/useTable";
import { Mensaje, Mensaje2 } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
// UI
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
  Select,
} from "../../../../ui/inputs/Input";

const headCells = [
  {
    id: "activo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Activo",
    textAlign: "center",
  },
  {
    id: "numPeriodo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Num. Período",
    textAlign: "center",
  },
  {
    id: "dia",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Día",
    textAlign: "center",
  },
  {
    id: "fechaInicio",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha de Inicio",
    textAlign: "center",
  },
  {
    id: "dia2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Día",
    textAlign: "center",
  },
  {
    id: "fechaFin",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha de Fin",
    textAlign: "center",
  },
];

const headCells2 = [
  {
    id: "activo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Activo",
    textAlign: "center",
  },
  {
    id: "codIntegrante",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Integrante",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
];

const headCells3 = [
  {
    id: "activo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Activo",
    textAlign: "center",
  },
  {
    id: "codIntegrante",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Integrante",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
];

const ActivarConceptoTable = ({ data, isDisabled }) => {
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    data,
    headCells2,
    filterFn
  );

  return (
    <TblContainer>
      <TblHead />
      <tbody>
        {data &&
          recordsAfterPagingAndSorting().map((item, index) => (
            <tr key={index}>
              <td className='align-baseline' style={{ textAlign: "center" }}>
                <Checkbox checked={item.activo === 1} readOnly disabled={isDisabled} />
              </td>
              <td className='align-baseline' style={{ textAlign: "center" }}>
                {item.codIntegrante}
              </td>
              <td className='align-baseline' style={{ textAlign: "left" }}>
                {item.nombre}
              </td>
            </tr>
          ))}
      </tbody>
    </TblContainer>
  );
};

const ActivarOtrosPagosTable = ({ data, isDisabled }) => {
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    data,
    headCells3,
    filterFn
  );

  return (
    <TblContainer>
      <TblHead />
      <tbody>
        {data &&
          recordsAfterPagingAndSorting().map((item, index) => (
            <tr key={index}>
              <td className='align-baseline' style={{ textAlign: "center" }}>
                <Checkbox checked={item.activo === 1} readOnly disabled={isDisabled} />
              </td>
              <td className='align-baseline' style={{ textAlign: "center" }}>
                {item.codIntegrante}
              </td>
              <td className='align-baseline' style={{ textAlign: "left" }}>
                {item.nombre}
              </td>
            </tr>
          ))}
      </tbody>
    </TblContainer>
  );
};

const FrecuenciaTable = ({ data, isDisabled }) => {
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    data,
    headCells,
    filterFn
  );

  return (
    <TblContainer>
      <TblHead />
      <tbody>
        {data &&
          recordsAfterPagingAndSorting().map((item, index) => (
            <tr key={index}>
              <td className='align-baseline' style={{ textAlign: "center" }}>
                <Checkbox checked={item.activo === 1} readOnly disabled={isDisabled} />
              </td>
              <td className='align-baseline' style={{ textAlign: "center" }}>{item.numper}</td>
              <td className='align-baseline' style={{ textAlign: "center" }}>{item.diaInicio}</td>
              <td className='align-baseline' style={{ textAlign: "center" }}>{item.fecini}</td>
              <td className='align-baseline' style={{ textAlign: "center" }}>{item.diaFin}</td>
              <td className='align-baseline' style={{ textAlign: "center" }}>{item.fecfin}</td>
            </tr>
          ))}
      </tbody>
    </TblContainer>
  );
};

export default function Conceptos({ show, setShow, setTabla, operacion, id }) {
  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');

  // Estados del formulario
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensaje2, setMensaje2] = useState({ mostrar: false, titulo: '', mensaje: '' });
  const [horaExtraDiurna, setHoraExtraDiurna] = useState(false);
  const [horaExtraNocturna, setHoraExtraNocturna] = useState(false);
  // Datos del concepto
  const [codConcepto, setCodConcepto] = useState('');
  const [nombre, setNombre] = useState('');
  const [status, setStatus] = useState('');
  const [cuentaPUC, setCuentaPUC] = useState('');
  const [conceptoFijo, setConceptoFijo] = useState('No');
  const [aportePatronal, setAportePatronal] = useState('No');
  const [general, setGeneral] = useState(false);
  const [despuesVacaciones, setDespuesVacaciones] = useState('No');
  const [activarVacaciones, setActivarVacaciones] = useState('No');
  const [numPeriodosVac, setNumPeriodosVac] = useState('1');
  const [categoriaFija, setCategoriaFija] = useState(false);
  const [claseTxt, setClaseTxt] = useState('');

  // Tipo Concepto
  const [tipoConcepto, setTipoConcepto] = useState('');
  const [afectaIntereses, setAfectaIntereses] = useState(false);
  const [tipoPrestamo, setTipoPrestamo] = useState(false);
  const [moduloVacaciones, setModuloVacaciones] = useState('No');
  const [moduloLiquidaciones, setModuloLiquidaciones] = useState('No');
  const [constanciaTrabajo, setConstanciaTrabajo] = useState('No');
  const [esISLR, setEsISLR] = useState(false);
  const [esCestaTicket, setEsCestaTicket] = useState(false);
  const [esFideicomiso, setEsFideicomiso] = useState(false);
  const [esPrima, setEsPrima] = useState(false);
  const [esPrimaAntiguedad, setEsPrimaAntiguedad] = useState(false);
  const [esPrimaEficiencia, setEsPrimaEficiencia] = useState(false);
  const [esPrimaTransporte, setEsPrimaTransporte] = useState(false);

  // Retenciones
  const [codRetencion, setCodRetencion] = useState('');
  const [descRetencion, setDescRetencion] = useState('');

  // Fórmulas
  const [formula, setFormula] = useState('');
  const [formulaMensual, setFormulaMensual] = useState('');
  const [porcentajePatrono, setPorcentajePatrono] = useState('');
  const [porcentajeTrabajador, setPorcentajeTrabajador] = useState('');
  const [cuentaPatrono, setCuentaPatrono] = useState('');

  // Tablas
  const [frecuenciaData, setFrecuenciaData] = useState([]);
  const [activarConceptosData, setActivarConceptosData] = useState([]);
  const [activarOtrosPagosData, setActivarOtrosPagosData] = useState([]);

  // Listas para combos
  const [listaStatus, setListaStatus] = useState(['Activo', 'Inactivo']);
  const [listaTipoConcepto, setListaTipoConcepto] = useState(['Asignación', 'Deducción']);
  const [listaClaseTxt, setListaClaseTxt] = useState([]);
  const [listaBuscar, setListaBuscar] = useState(['Cod. Integrante', 'Nombre']);

  // Obtener código de nómina
  const codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '') || '';

  // Cargar datos del concepto cuando se abre en modo edición/consulta/eliminación
  useEffect(() => {
    if (show && id && operacion !== 1) {
      cargarConcepto(id);
    }
    if (show && operacion === 1) {
      limpiarFormulario();
    }
    if (show) {
      cargarClaseTxt();
      cargarFrecuencia();
      cargarActivarConceptos();
      cargarActivarOtrosPagos();
    }
  }, [show, id, operacion]);

  const cargarConcepto = async (conceptoId) => {
    setActivate(true);
    try {
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=nomi${codigoNomina}.conceptos&condi=codconcep='${conceptoId}'&orden=codconcep`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200 && response.data.length > 0) {
        const data = response.data[0];
        setCodConcepto(data.codconcep?.toString().padStart(4, '0') || '');
        setNombre(data.nomconcep || '');
        setStatus(data.status === 1 ? 'Activo' : 'Inactivo');
        setCuentaPUC(data.cuencon || '');
        setConceptoFijo(data.fijo === 1 ? 'Si' : 'No');
        setAportePatronal(data.apopatro === 1 ? 'Si' : 'No');
        setGeneral(data.general === 1);
        setDespuesVacaciones(data.actvac === 1 ? 'Si' : 'No');
        setActivarVacaciones(data.peractvac === 1 ? 'Si' : 'No');
        setNumPeriodosVac(data.numpervac?.toString() || '1');
        setCategoriaFija(data.catfija === 1);
        setTipoConcepto(data.tipconcep === 'Asignación' ? 'Asignación' : 'Deducción');
        setAfectaIntereses(data.afeint === 1);
        setTipoPrestamo(data.tipopres === 1);
        setModuloVacaciones(data.modvac === 1 ? 'Si' : 'No');
        setModuloLiquidaciones(data.modliq === 1 ? 'Si' : 'No');
        setConstanciaTrabajo(data.constrab === 1 ? 'Si' : 'No');
        setEsISLR(data.esisrl === 1);
        setEsCestaTicket(data.escestaticket === 1);
        setEsFideicomiso(data.esfideicomiso === 1);
        setEsPrima(data.esprima === 1);
        setEsPrimaAntiguedad(data.esprimaantigue === 1);
        setEsPrimaEficiencia(data.esprimaeficiencia === 1);
        setEsPrimaTransporte(data.estransporte === 1);
        setHoraExtraDiurna(data.eshoraextrad === 1);
        setHoraExtraNocturna(data.eshoraextran === 1);
        setFormula(data.formula || '');
        setFormulaMensual(data.formulamen || '');
        setPorcentajePatrono(data.porpatro?.toString() || '0');
        setPorcentajeTrabajador(data.portra?.toString() || '0');
        setCuentaPatrono(data.codapopat || '');

        if (data.idtiporetencion && data.idtiporetencion !== 0) {
          setCodRetencion(data.idtiporetencion.toString());
          cargarRetencion(data.idtiporetencion);
        }
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const cargarRetencion = async (idRetencion) => {
    try {
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=tiporetencion&condi=idtiporetencion='${idRetencion}'&orden=idtiporetencion`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });
      if (response.status === 200 && response.data.length > 0) {
        setDescRetencion(response.data[0].descripcion || '');
      }
    } catch (error) {
      console.error('Error al cargar retención:', error);
    }
  };

  const cargarClaseTxt = async () => {
    try {
      let endpoint = `${op.conexion}/api/consulta/selecionarregistros?campos=*&nomtab=clasetxtnomina&orden=idclase`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });
      if (response.status === 200) {
        const opciones = response.data.map(item => item.descripcion);
        setListaClaseTxt(opciones);
      }
    } catch (error) {
      console.error('Error al cargar clase txt:', error);
    }
  };

  const cargarFrecuencia = async () => {
    try {
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=nomi${codigoNomina}.perconceptos&condi=codconcep='${id || ''}'&orden=numper`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });
      if (response.status === 200) {
        setFrecuenciaData(response.data);
      }
    } catch (error) {
      console.error('Error al cargar frecuencia:', error);
    }
  };

  const cargarActivarConceptos = async () => {
    try {
      let endpoint = `${op.conexion}/api/consulta/selecionar_conceptosinte?codconcep=${id || ''}&esquema=nomi${codigoNomina}`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });
      if (response.status === 200) {
        setActivarConceptosData(response.data);
      }
    } catch (error) {
      console.error('Error al cargar activar conceptos:', error);
    }
  };

  const cargarActivarOtrosPagos = async () => {
    try {
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=nomi${codigoNomina}.conceptosotrospagos&condi=codconcep='${id || ''}'&orden=codint`;
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });
      if (response.status === 200) {
        setActivarOtrosPagosData(response.data);
      }
    } catch (error) {
      console.error('Error al cargar activar otros pagos:', error);
    }
  };

  const limpiarFormulario = () => {
    setHoraExtraDiurna(false);
    setHoraExtraNocturna(false);
    setCodConcepto('');
    setNombre('');
    setStatus('Activo');
    setCuentaPUC('');
    setConceptoFijo('No');
    setAportePatronal('No');
    setGeneral(false);
    setDespuesVacaciones('No');
    setActivarVacaciones('No');
    setNumPeriodosVac('1');
    setCategoriaFija(false);
    setTipoConcepto('Asignación');
    setAfectaIntereses(false);
    setTipoPrestamo(false);
    setModuloVacaciones('No');
    setModuloLiquidaciones('No');
    setConstanciaTrabajo('No');
    setEsISLR(false);
    setEsCestaTicket(false);
    setEsFideicomiso(false);
    setEsPrima(false);
    setEsPrimaAntiguedad(false);
    setEsPrimaEficiencia(false);
    setEsPrimaTransporte(false);
    setFormula('');
    setFormulaMensual('');
    setPorcentajePatrono('');
    setPorcentajeTrabajador('');
    setCuentaPatrono('');
    setCodRetencion('');
    setDescRetencion('');
    setClaseTxt('');
  };

  const guardarConcepto = async () => {
    // Validaciones
    if (!codConcepto) {
      setMensaje({
        mostrar: true,
        titulo: 'Validación',
        texto: 'El código del concepto es requerido',
        icono:'informacion'
      });
      return;
    }
    if (!nombre) {
      setMensaje({
        mostrar: true,
        titulo: 'Validación',
        texto: 'El nombre del concepto es requerido',
        icono:'informacion'

      });
      return;
    }
    if (!cuentaPUC) {
      setMensaje({
        mostrar: true,
        titulo: 'Validación',
        texto: 'La cuenta PUC es requerida',
        icono:'informacion'

      });
      return;
    }
    if (aportePatronal === 'Si' && !porcentajePatrono) {
      setMensaje({
        mostrar: true,
        titulo: 'Validación',
        texto: 'El porcentaje aporte patrono es requerido',
        icono: 'informacion'
      });
      return;
    }
    if (aportePatronal === 'Si' && !porcentajeTrabajador) {
      setMensaje({
        mostrar: true,
        titulo: 'Validación',
        texto: 'El porcentaje aporte trabajador es requerido',
        icono: 'informacion'

      });
      return;
    }

    setActivate(true);
    try {
      // Preparar los datos con los nombres exactos que espera el backend
      const data = {
        operacion: operacion,
        ccodconcep: codConcepto.padStart(4, '0'),
        cnomconcep: nombre.toUpperCase(),
        ctipconcep: tipoConcepto === 'Asignación' ? 'Asignación' : 'Deducción',
        cformula: formula.toUpperCase(),
        ccodpresu: '',
        ccuencon: cuentaPUC,
        napopatro: aportePatronal === 'Si' ? 1 : 2,
        nmodvac: moduloVacaciones === 'Si' ? 1 : 2,
        nmodliq: moduloLiquidaciones === 'Si' ? 1 : 2,
        bgeneral: general ? 1 : 0,
        bafeint: afectaIntereses ? 1 : 0,
        nporpatro: parseFloat(porcentajePatrono?.replace(/\./g, '').replace(',', '.') || 0),
        nportra: parseFloat(porcentajeTrabajador?.replace(/\./g, '').replace(',', '.') || 0),
        nfijo: conceptoFijo === 'Si' ? 1 : 2,
        nactvac: despuesVacaciones === 'Si' ? 1 : 2,
        nnumpervac: parseInt(numPeriodosVac) || 1,
        btipopres: tipoPrestamo ? 1 : 0,
        ccodapopat: cuentaPatrono || '',
        esquema1: `nomi${codigoNomina}`,
        ccodnomi: codigoNomina,
        idtiporetencion: parseInt(codRetencion) || 0,
        bcatfija: categoriaFija ? true : false,
        csector: categoriaFija ? '01' : '',
        cdessec: categoriaFija ? 'SECTOR' : '',
        cprogra: categoriaFija ? '01' : '',
        cdespro: categoriaFija ? 'PROGRAMA' : '',
        cactivi: categoriaFija ? '01' : '',
        cdesact: categoriaFija ? 'ACTIVIDAD' : '',
        bconstrab: constanciaTrabajo === 'Si' ? 1 : 0,
        csubprogra: categoriaFija ? '01' : '',
        cdessubpro: categoriaFija ? 'SUBPROGRAMA' : '',
        cproye: categoriaFija ? '01' : '',
        cdesproye: categoriaFija ? 'PROYECTO' : '',
        cformulamen: formulaMensual.toUpperCase(),
        besisrl: esISLR ? 1 : 0,
        nclasetxt: listaClaseTxt.indexOf(claseTxt) + 1 || 0,
        bantigue: esPrimaAntiguedad ? 1 : 0,
        bprima: esPrima ? 1 : 0,
        beficiencia: esPrimaEficiencia ? 1 : 0,
        nperactvac: activarVacaciones === 'Si' ? 1 : 2,
        nstatus: status === 'Activo' ? 1 : 2,
        bticket: esCestaTicket ? 1 : 0,
        bfideico: esFideicomiso ? 1 : 0,
        btransporte: esPrimaTransporte ? 1 : 0,
        bhoraextrad: horaExtraDiurna ? 1 : 0,
        bhoraextran: horaExtraNocturna ? 1 : 0
      };

      let endpoint = `${op.conexion}/api/nomina/concepto_act`;
      const response = await axios.post(endpoint, data, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: response.data.message || 'Concepto guardado exitosamente',
          icono: 'exito'
        });
        setShow(false);
        if (setTabla) setTabla();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const eliminarConcepto = async () => {
    setActivate(true);
    try {
      let endpoint = `${op.conexion}/api/conceptos/eliminar?codconcep=${codConcepto}&codigonomina=${codigoNomina}`;
      const response = await axios.delete(endpoint, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: response.data.message || 'Concepto eliminado exitosamente',
          icono: 'exito'
        });
        setShow(false);
        if (setTabla) setTabla();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const salir = () => {
    setShow(false);
    if (setTabla) setTabla();
  };

  const aceptar = () => {
    if (operacion === 3) {
      eliminarConcepto();
    } else {
      guardarConcepto();
    }
  };

  const cancelar = () => {
    setShow(false);
    if (setTabla) setTabla();
  };

  // Determinar si los campos deben estar deshabilitados (consulta o eliminación)
  const isDisabled = operacion === 4 || operacion === 3;
  const isDeleteMode = operacion === 3;

  return (
    <>
      <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
        <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
          <h3 className="fw-bold m-0">
            {operacion === 1 ? 'Incluir Concepto' :
              operacion === 2 ? 'Editar Concepto' :
                operacion === 3 ? 'Eliminar Concepto' : 'Consultar Concepto'}
          </h3>
          <a type="button" className="fw-bold text-light fs-6" onClick={salir} style={{ cursor: 'pointer' }}>
            Salir <i className="fa fa-times ms-2"></i>
          </a>
        </Modal.Header>
        <Modal.Body className="col-12 m-0 p-2">
          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link active bg-blue-100 text-light"
                id="concepto-tab"
                data-bs-toggle="tab"
                data-bs-target="#concepto-tab-pane"
                type="button"
                role="tab"
                aria-controls="concepto-tab-pane"
                aria-selected="true"
              >
                Concepto
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link bg-blue-200 text-light"
                id="tipoConcepto-tab"
                data-bs-toggle="tab"
                data-bs-target="#tipoConcepto-tab-pane"
                type="button"
                role="tab"
                aria-controls="tipoConcepto-tab-pane"
                aria-selected="false"
              >
                Tipo Concepto
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link bg-blue-300 text-light"
                id="formulas-tab"
                data-bs-toggle="tab"
                data-bs-target="#formulas-tab-pane"
                type="button"
                role="tab"
                aria-controls="formulas-tab-pane"
                aria-selected="false"
              >
                Fórmulas
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link bg-blue-400 text-light"
                id="frecuencia-tab"
                data-bs-toggle="tab"
                data-bs-target="#frecuencia-tab-pane"
                type="button"
                role="tab"
                aria-controls="frecuencia-tab-pane"
                aria-selected="false"
              >
                Frecuencia
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link bg-blue-500 text-light"
                id="activarConceptos-tab"
                data-bs-toggle="tab"
                data-bs-target="#activarConceptos-tab-pane"
                type="button"
                role="tab"
                aria-controls="activarConceptos-tab-pane"
                aria-selected="false"
              >
                Activar Conceptos
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link bg-blue-600 text-light"
                id="activarOtrosPagos-tab"
                data-bs-toggle="tab"
                data-bs-target="#activarOtrosPagos-tab-pane"
                type="button"
                role="tab"
                aria-controls="activarOtrosPagos-tab-pane"
                aria-selected="false"
              >
                Activar Otros Pagos
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            {/* Pestaña Concepto */}
            <div
              className="tab-pane fade show active"
              id="concepto-tab-pane"
              role="tabpanel"
              aria-labelledby="concepto-tab"
              tabIndex="0"
            >
              <form
                onSubmit={(e) => e.preventDefault()}
                className="col-12 m-0 p-0 d-flex flex-wrap"
              >
                <div className="col-2 m-0 mb-2 p-0">
                  <Input
                    label="Cod. Concepto:"
                    value={codConcepto}
                    onChange={(e) => setCodConcepto(e.target.value)}
                    disabled={isDisabled || operacion === 2}
                  />
                </div>
                <div className="col-8 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Nombre:"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Select
                    label="Status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={isDisabled}
                  >
                    {listaStatus.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </Select>
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label="Cuenta PUC:"
                    value={cuentaPUC}
                    onChange={(e) => setCuentaPUC(e.target.value)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-9 m-0 mb-2 p-0 pl-2 d-flex gap-5 align-items-center">
                  <div className="col-auto m-0 p-0 d-flex gap-2 align-items-center">
                    <span className="fw-bold">Concepto Fijo:</span>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Si"
                        name="conceptoFijo"
                        id="conceptoFijo_si"
                        checked={conceptoFijo === 'Si'}
                        onChange={() => setConceptoFijo('Si')}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No"
                        name="conceptoFijo"
                        id="conceptoFijo_no"
                        checked={conceptoFijo === 'No'}
                        onChange={() => setConceptoFijo('No')}
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  <div className="col-auto m-0 p-0 d-flex gap-2 align-items-center">
                    <span className="fw-bold">Aporte Patronal:</span>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Si"
                        name="aportePatronal"
                        id="aportePatronal_si"
                        checked={aportePatronal === 'Si'}
                        onChange={() => setAportePatronal('Si')}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No"
                        name="aportePatronal"
                        id="aportePatronal_no"
                        checked={aportePatronal === 'No'}
                        onChange={() => setAportePatronal('No')}
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="General"
                      id="general"
                      checked={general}
                      onChange={(e) => setGeneral(e.target.checked)}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
                <div className="col-6 m-0 mb-2 p-0 d-flex gap-5 align-items-center">
                  <div className="col-auto m-0 p-0 d-flex gap-2 align-items-center">
                    <span className="fw-bold">
                      Activar Despues de Vacaciones:
                    </span>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Si"
                        name="despuesVacaciones"
                        id="despuesVacaciones_si"
                        checked={despuesVacaciones === 'Si'}
                        onChange={() => setDespuesVacaciones('Si')}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No"
                        name="despuesVacaciones"
                        id="despuesVacaciones_no"
                        checked={despuesVacaciones === 'No'}
                        onChange={() => setDespuesVacaciones('No')}
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  <div className="col-auto m-0 p-0 d-flex gap-2 align-items-center">
                    <span className="fw-bold">Activar en Vacaciones:</span>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Si"
                        name="activarVacaciones"
                        id="activarVacaciones_si"
                        checked={activarVacaciones === 'Si'}
                        onChange={() => setActivarVacaciones('Si')}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No"
                        name="activarVacaciones"
                        id="activarVacaciones_no"
                        checked={activarVacaciones === 'No'}
                        onChange={() => setActivarVacaciones('No')}
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 m-0 p-0 d-flex">
                  <div className="col-4 m-0 p-0">
                    <Input
                      label="Num. Períodos Vacaciones:"
                      value={numPeriodosVac}
                      onChange={(e) => setNumPeriodosVac(e.target.value)}
                      disabled={isDisabled}
                      type="number"
                    />
                  </div>
                  <div className="col-4 m-0 p-0 d-flex justify-content-center align-items-center">
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Categoría Fija"
                        id="categoriaFija"
                        checked={categoriaFija}
                        onChange={(e) => setCategoriaFija(e.target.checked)}
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  <div className="col-4 m-0 p-0">
                    <Select
                      label="Clase Txt:"
                      value={claseTxt}
                      onChange={(e) => setClaseTxt(e.target.value)}
                      disabled={isDisabled}
                    >
                      <option value="">Seleccione...</option>
                      {listaClaseTxt.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </div>
                </div>
              </form>
            </div>

            {/* Pestaña Tipo Concepto */}
            <div
              className="tab-pane fade"
              id="tipoConcepto-tab-pane"
              role="tabpanel"
              aria-labelledby="tipoConcepto-tab"
              tabIndex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap justify-content-between">
                <div className="col-3 m-0 mb-2 p-0">
                  <Select
                    label="Tipo:"
                    value={tipoConcepto}
                    onChange={(e) => setTipoConcepto(e.target.value)}
                    disabled={isDisabled}
                  >
                    {listaTipoConcepto.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </Select>
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Afecta Intereses Sobre Prestaciones"
                    id="afectaIntereses"
                    checked={afectaIntereses}
                    onChange={(e) => setAfectaIntereses(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Tipo Prestamo"
                    id="tipoPrestamo"
                    checked={tipoPrestamo}
                    onChange={(e) => setTipoPrestamo(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">Modulos de Vacaciones:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="Si"
                      name="moduloVacaciones"
                      id="moduloVacaciones_si"
                      checked={moduloVacaciones === 'Si'}
                      onChange={() => setModuloVacaciones('Si')}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="No"
                      name="moduloVacaciones"
                      id="moduloVacaciones_no"
                      checked={moduloVacaciones === 'No'}
                      onChange={() => setModuloVacaciones('No')}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
                <div className="col-4 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">Modulos de Liquidaciones:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="Si"
                      name="moduloLiquidaciones"
                      id="moduloLiquidaciones_si"
                      checked={moduloLiquidaciones === 'Si'}
                      onChange={() => setModuloLiquidaciones('Si')}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="No"
                      name="moduloLiquidaciones"
                      id="moduloLiquidaciones_no"
                      checked={moduloLiquidaciones === 'No'}
                      onChange={() => setModuloLiquidaciones('No')}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
                <div className="col-4 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">
                    Mostrar en Constancia de Trabajo:
                  </span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="Si"
                      name="constanciaTrabajo"
                      id="constanciaTrabajo_si"
                      checked={constanciaTrabajo === 'Si'}
                      onChange={() => setConstanciaTrabajo('Si')}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="No"
                      name="constanciaTrabajo"
                      id="constanciaTrabajo_no"
                      checked={constanciaTrabajo === 'No'}
                      onChange={() => setConstanciaTrabajo('No')}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es I.S.L.R"
                    id="islr"
                    checked={esISLR}
                    onChange={(e) => setEsISLR(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Cesta Ticket"
                    id="cestaTicket"
                    checked={esCestaTicket}
                    onChange={(e) => setEsCestaTicket(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Fideicomiso"
                    id="fideicomiso"
                    checked={esFideicomiso}
                    onChange={(e) => setEsFideicomiso(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Prima"
                    id="prima"
                    checked={esPrima}
                    onChange={(e) => setEsPrima(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es prima de Antiguedad"
                    id="primaAntiguedad"
                    checked={esPrimaAntiguedad}
                    onChange={(e) => setEsPrimaAntiguedad(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Prima de eficiencia"
                    id="primaEficiencia"
                    checked={esPrimaEficiencia}
                    onChange={(e) => setEsPrimaEficiencia(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Prima de Transporte"
                    id="primaTransporte"
                    checked={esPrimaTransporte}
                    onChange={(e) => setEsPrimaTransporte(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Hora Extra Diurna"
                    id="horaExtraDiurna"
                    checked={horaExtraDiurna}
                    onChange={(e) => setHoraExtraDiurna(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Checkbox
                    label="Es Hora Extra Nocturna"
                    id="horaExtraNocturna"
                    checked={horaExtraNocturna}
                    onChange={(e) => setHoraExtraNocturna(e.target.checked)}
                    disabled={isDisabled}
                  />
                </div>
                <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                  <legend className="float-none w-auto m-0">Retenciones</legend>
                  <div className="col-3 m-0 p-0">
                    <SearchInput
                      label="Código:"
                      value={codRetencion}
                      onChange={(e) => setCodRetencion(e.target.value)}
                      disabled={isDisabled || tipoConcepto !== 'Deducción'}
                    />
                  </div>
                  <div className="col-9 m-0 p-0 pl-2">
                    <Input
                      label="Descripción:"
                      value={descRetencion}
                      disabled
                    />
                  </div>
                </fieldset>
              </div>
            </div>

            {/* Pestaña Fórmulas */}
            <div
              className="tab-pane fade"
              id="formulas-tab-pane"
              role="tabpanel"
              aria-labelledby="formulas-tab"
              tabIndex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Fórmula:"
                    value={formula}
                    onChange={(e) => setFormula(e.target.value)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Formula Para Calculo Mensual:"
                    value={formulaMensual}
                    onChange={(e) => setFormulaMensual(e.target.value)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Porcentaje Aporte Patrono:"
                    value={porcentajePatrono}
                    onChange={(e) => setPorcentajePatrono(e.target.value)}
                    disabled={isDisabled || aportePatronal !== 'Si'}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Porcentaje Aporte Trabajador:"
                    value={porcentajeTrabajador}
                    onChange={(e) => setPorcentajeTrabajador(e.target.value)}
                    disabled={isDisabled || aportePatronal !== 'Si'}
                  />
                </div>
                <div className="col-12 m-0 p-0">
                  <Input
                    label="Cuenta Contable Aporte Patrono:"
                    value={cuentaPatrono}
                    onChange={(e) => setCuentaPatrono(e.target.value)}
                    disabled={isDisabled || aportePatronal !== 'Si'}
                  />
                </div>
              </div>
            </div>

            {/* Pestaña Frecuencia */}
            <div
              className="tab-pane fade"
              id="frecuencia-tab-pane"
              role="tabpanel"
              aria-labelledby="frecuencia-tab"
              tabIndex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-11 m-0 p-0">
                  <FrecuenciaTable data={frecuenciaData} isDisabled={isDisabled} />
                </div>
                <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
                  <div className="col-auto m-0 p-0">
                    <InfoButton icon="fa-eye m-0" disabled={isDisabled} />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <WarningButton icon="fa-edit m-0" disabled={isDisabled} />
                  </div>
                </div>
                <div className="col-12 m-0 p-0 d-flex align-items-center justify-content-center gap-2">
                  <div className="col-auto m-0 p-0">
                    <PrimaryButton disabled={isDisabled}>Activar Todos</PrimaryButton>
                  </div>
                  <div className="col-auto m-0 p-0">
                    <DangerButton icon="m-0" disabled={isDisabled}>Desactivar Todos</DangerButton>
                  </div>
                </div>
              </div>
            </div>

            {/* Pestaña Activar Conceptos */}
            <div
              className="tab-pane fade"
              id="activarConceptos-tab-pane"
              role="tabpanel"
              aria-labelledby="activarConceptos-tab"
              tabIndex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded d-flex align-items-center">
                  <legend className="float-none w-auto m-0">Buscar Por</legend>
                  <div className="col-3 m-0 p-0 pr-2">
                    <Select>
                      {listaBuscar.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </div>
                  <div className="col m-0 p-0">
                    <Input />
                  </div>
                  <div className="col-auto m-0 p-0 pl-2">
                    <PrimaryButton icon="fa-arrow-right m-0" disabled={isDisabled} />
                  </div>
                </fieldset>
                <ActivarConceptoTable data={activarConceptosData} isDisabled={isDisabled} />
                <div className="col-12 m-0 p-0 d-flex align-items-center justify-content-center gap-2">
                  <div className="col-auto m-0 p-0">
                    <PrimaryButton disabled={isDisabled}>Activar Todos</PrimaryButton>
                  </div>
                  <div className="col-auto m-0 p-0">
                    <DangerButton icon="m-0" disabled={isDisabled}>Desactivar Todos</DangerButton>
                  </div>
                </div>
              </div>
            </div>

            {/* Pestaña Activar Otros Pagos */}
            <div
              className="tab-pane fade"
              id="activarOtrosPagos-tab-pane"
              role="tabpanel"
              aria-labelledby="activarOtrosPagos-tab"
              tabIndex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded d-flex align-items-center">
                  <legend className="float-none w-auto m-0">Buscar Por</legend>
                  <div className="col-3 m-0 p-0 pr-2">
                    <Select>
                      {listaBuscar.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </div>
                  <div className="col m-0 p-0">
                    <Input />
                  </div>
                  <div className="col-auto m-0 p-0 pl-2">
                    <PrimaryButton icon="fa-arrow-right m-0" disabled={isDisabled} />
                  </div>
                </fieldset>
                <ActivarOtrosPagosTable data={activarOtrosPagosData} isDisabled={isDisabled} />
                <div className="col-12 m-0 p-0 d-flex align-items-center justify-content-center gap-2">
                  <div className="col-auto m-0 p-0">
                    <PrimaryButton disabled={isDisabled}>Activar Todos</PrimaryButton>
                  </div>
                  <div className="col-auto m-0 p-0">
                    <DangerButton icon="m-0" disabled={isDisabled}>Desactivar Todos</DangerButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {!isDeleteMode && <SuccessButton onClick={aceptar} disabled={isDisabled}>Aceptar</SuccessButton>}
          {isDeleteMode && <DangerButton onClick={aceptar}>Eliminar</DangerButton>}
          <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        </Modal.Footer>
      </Modal>

      {/* Spinner */}
      <Dimmer active={activate} inverted />

      {/* Mensaje con icono (éxito, error, información) */}
      <Mensaje
        mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })}
      />

      {/* Mensaje simple (sin icono) */}
      <Mensaje2
        show={mensaje2.mostrar}
        titulo={mensaje2.titulo}
        mensaje={mensaje2.mensaje}
        onHide={() => setMensaje2({ mostrar: false, titulo: '', mensaje: '' })}
      />
    </>
  );
}